import AppRoutes from "routes";
import { useSentryUser } from "utils/hooks/useSentryUser";

const App = () => {
	useSentryUser();
	return <AppRoutes />;
};
export default App;
